<template>
    <div class="version1-left-middle">
        <Header title="专利运营转化"></Header>
        <div class="warp">
            <div class="warp-row" v-for="(item,index) in list" :key="index" @click="echartClick(item)">
                <div class="text" :style="{color: item.color}">{{ item.text }}</div>
                <div class="name">{{ item.name }}</div>
                <img :src="item.imgSrc" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import Header from './header.vue'
import { getTransferRange } from '@/api/databaseBin'
import BaseMixin from '@/views/_mixin'
export default {
  mixins: [BaseMixin],
  data() {
    return {
      list: [
        {
          text: 0,
          name: '专利转让/件数',
          imgSrc: require('../../../../../static/version1/专利转让件数图标.png'),
          color: '#00A6F3',
          value: 'transfer',
          type: '转让'
        },
        {
          text: 0,
          name: '专利许可/件数',
          imgSrc: require('../../../../../static/version1/专利许可件数.png'),
          color: '#00F0ED',
          value: 'permit',
          type: '许可'
        },
        {
          text: 0,
          name: '专利质押/件数',
          imgSrc: require('../../../../../static/version1/专利质押件数.png'),
          color: '#FED52F',
          value: 'pledege',
          type: '质押'
        }
      ]
    }
  },
  components: {
    Header
  },
  mounted() {
    this.transferRange()
  },
  methods: {
    echartClick(params) {
      this.jumpIpi('法律事件=' + params.type, 'isMerge', 'publicOrder')
    },
    transferRange() {
      getTransferRange().then(res => {
        if (res[this.codeMapping]) {
          this.transferList = res[this.dataMapping]
          this.transferList.forEach(item => {
            this.list.forEach(ele => {
              if (item.name === ele.value) {
                ele.text = item.count
              }
            })
          })
        }
      })
    }
  }
}
</script>
